<div class="header">
  @if (name && !isUserProfile) {
    <h3>{{ name }}</h3>
  } @else if (isUserProfile) {
    <h3>{{ 'user.details.profile' | translate }}</h3>
  } @else {
    <h3>{{ 'profile.userDetail' | translate }}</h3>
  }

  @if (!isUserProfile) {
    <a class="back-link"
       (click)="backToUsers()"
       (keydown.enter)="backToUsers()"
       tabindex="0">
      &lt;&lt;&nbsp;{{ 'common.backTo' | translate }}
      <span id="prev-url-name">{{ 'user.details.users' | translate }}</span>
    </a>
  }
</div>

@if (isLoader()) {
  <app-loader></app-loader>
}

<div class="details-container">
  <div class="details-card user-details">
    <div class="details-header">
      <h5>{{ 'profile.userDetail' | translate }}</h5>
      <div id="user-status" class="status-button" [class.green]="isActive" [class.red]="!isActive">
        <div class="status-circle"></div>
        <span class="status-text">
          {{ isActive ? 'Active' : 'Inactive' }}
        </span>
      </div>
    </div>

    <div class="detail-row">
      <span class="row-key">{{ 'profile.username' | translate }}</span>
      <span class="row-value">{{ userName }}</span>
    </div>

    <div class="detail-row">
      <span class="row-key">{{ 'user.details.phone' | translate }}</span>
      <span class="row-value">{{ phoneNumber ? formatPhoneNumber(phoneNumber) : '--' }}</span>
    </div>

    <div class="detail-row">
      <span class="row-key">{{ 'profile.email' | translate }}</span>
      <span class="row-value">{{ userEmail }}</span>
    </div>

    <div class="detail-row">
      <span class="row-key">{{ 'profile.address' | translate }}</span>
      <span class="row-value">{{ address }}</span>
    </div>

    @if (userAuthenticationType !== 'APIOnly' && userAuthenticationType !== 2) {
      <div class="detail-row">
        <span class="row-key">{{ 'profile.password' | translate }}</span>
        <span class="row-value">{{ 'user.details.lastModifiedOn' | translate }} {{ modifiedOn | date }}</span>
      </div>
    }

    @if (isActive) {
      @if (newAPIKey) {
        <div class="detail-row">
          <span class="row-key">{{ 'user.details.APIKey' | translate }}</span>
          <span class="row-value">
            @if (!showKey) {
              <span class="api-key hidden">**************************************</span>
            } @else {
              <span class="api-key visible" [title]="newAPIKey">{{ newAPIKey }}</span>
            }
  
            <i class="bi"
               [ngClass]="showKey ? 'bi-eye-slash hide-key' : 'bi-eye show-key'"
               (click)="toggleApiKey()"
               (keydown.enter)="toggleApiKey()"
               tabindex="0"></i>
  
            <span class="material-symbols-outlined copy-icon"
                  (click)="allyCommonService.copyValueToClipboard(newAPIKey)"
                  (keydown.enter)="allyCommonService.copyValueToClipboard(newAPIKey)"
                  tabindex="0">
              &#xe14d;
            </span>
          </span>
        </div>
      }
  
      @if (oldAPIKey) {
        <div class="detail-row">
          <span class="row-key">{{ 'user.details.oldAPIKey' | translate }}</span>
          <span class="row-value">
            @if (!showOldKey) {
              <span class="api-key hidden">**************************************</span>
            } @else {
              <span class="api-key visible" [title]="oldAPIKey">{{ oldAPIKey }}</span>
            }
  
            <i class="bi"
               [ngClass]="showOldKey ? 'bi-eye-slash hide-key' : 'bi-eye show-key'"
               (click)="toggleOldApiKey()"
               (keydown.enter)="toggleOldApiKey()"
               tabindex="0"></i>
  
            <span class="material-symbols-outlined copy-icon"
                  (click)="allyCommonService.copyValueToClipboard(oldAPIKey)"
                  (keydown.enter)="allyCommonService.copyValueToClipboard(oldAPIKey)"
                  tabindex="0">
              &#xe14d;
            </span>
          </span>
        </div>
      }
    }
  </div>

  <div class="details-card actions">
    <div class="details-header">
      <h5>{{ 'Actions' | translate }}</h5>
    </div>

    @if (userAuthenticationType !== 'APIOnly' && userAuthenticationType !== 2) {
      <a class="button button-green"
         (click)="showEditModal()"
         (keydown.enter)="showEditModal()"
         tabindex="0">
        {{ 'user.details.editUser' | translate }}
      </a>
    }

    @if (isActive && userAuthenticationType !== 'BearerOnly' && userAuthenticationType !== 1) {
      <a class="button button-green"
         (click)="showApiModal()"
         (keydown.enter)="showApiModal()"
         tabindex="0">
        {{ 'user.details.rollAPIKey' | translate }}
      </a>
    }

    @if (!isUserProfile && userAuthenticationType !== 'APIOnly' && userAuthenticationType !== 2) {
      <a class="button button-green"
         (click)="changePassword()"
         (keydown.enter)="changePassword()"
         [style.pointer-events]="isLoader() ? 'none' : null"
         tabindex="0">
        {{ 'user.details.sendPasswordReset' | translate }}
      </a>
    }

    @if (isUserProfile && userAuthenticationType !== 'APIOnly' && userAuthenticationType !== 2) {
      <a class="button button-green"
         (click)="routeToChangePassword()"
         (keydown.enter)="routeToChangePassword()"
         tabindex="0">
        {{ 'user.details.changePassword' | translate }}
      </a>
    }

    @if (!isActive && !isUserProfile) {
      <a class="button button-green"
         (click)="userActivate()"
         (keydown.enter)="userActivate()"
         [style.pointer-events]="isLoader() ? 'none' : null"
         tabindex="0">
        {{ 'profile.activate' | translate }}
      </a>
    }

    @if (isActive && !isUserProfile) {
      <a class="button button-green"
         (click)="userDeactivate()"
         (keydown.enter)="userDeactivate()"
         [style.pointer-events]="isLoader() ? 'none' : null"
         tabindex="0">
        {{ 'profile.deactivate' | translate }}
      </a>
    }
  </div>
</div>